module.exports = __webpack_public_path__ + "img/Img1b_204713_CeEv-5-433.f50e72f4.jpg";